import React from "react";
import "./LandingPage.scss";
import { Container, Grid, Box } from "@mui/material";
import VerifiedExpertBacked from "../../assets/Icons/VerifiedExpertBacked.svg";
import DailyInstaSwingRecommendations from "../../assets/Icons/DailyInstaSwingRecommendations.svg";
import AvgSuccessrate from "../../assets/Icons/AvgSuccessrate.svg";
import CryptoCoinsCovered from "../../assets/Icons/CryptoCoinsCovered.svg";
import CryptooAntsPremiumIcon from "../../assets/Icons/CryptooAntsPremiumIcon.svg";
import CryptoBuzzIcon from "../../assets/Icons/CryptoBuzzIcon.svg";
import CryptooAntsPremiumImage from "../../assets/Images/CryptooAntsPremiumImage.svg";
import CryptoBuzzImage from "../../assets/Images/CryptoBuzzImage.svg";
import VerifiedCryptoExperts from "../../assets/Icons/VerifiedCryptoExperts.svg";
import HumanAIPrecision from "../../assets/Icons/HumanAIPrecision.svg";
import InstantAlert from "../../assets/Icons/InstantAlert.svg";
import RealTimerecommendationtracking from "../../assets/Icons/RealTimerecommendationtracking.svg";
import avatar from "../../assets/Icons/avatar.svg";
import rightArrow from "../../assets/Icons/rightArrow.svg";
import icon3 from "../../assets/Icons/icon3.svg";
import icon4 from "../../assets/Icons/icon4.svg";
import aboutGroup from "../../assets/Images/aboutGroup.png";
import Footerimg from "../../assets/Images/Footerimg.svg";
import facebook from "../../assets/Icons/facebook.png";
import instagram from "../../assets/Icons/instagram.png";
import linkedin from "../../assets/Icons/linkedin.png";
import twitter1 from "../../assets/Icons/twitter 1.png";
import LaptopMockups from "../../assets/Images/LaptopMockups.svg";
import gmail from "../../assets/Icons/gmail.svg";

export default function LandingPage() {
  return (
    <div className="landing-wrapper">

      {/* Hero Section */}
      <section className="hero-section">
        <Container className="hero-content">
          <Grid container alignItems="center">

            <Grid size={{ xs: 12, md: 6 }}>
              <h1 className="hero-title">
                Marketplace For <br />
                <span className="highlight">Crypto Price Estimates</span>
              </h1>

              <p className="hero-subtitle">
                Get Access To Verified Crypto Experts Price Estimates
              </p>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={{ textAlign: "center" }} className="laptop-wrapper">
              <img
                src={LaptopMockups}
                alt="Laptop"
                className="laptop-img"
              />

              <div className="video-frame">
                <iframe
                  src="https://www.youtube.com/embed/K175ByNOmuA?autoplay=1&mute=1&controls=0&modestbranding=1&showinfo=0&rel=0&playsinline=1&loop=1&playlist=K175ByNOmuA"
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </Grid>

          </Grid>
        </Container>
      </section>

      {/* WHY SECTION */}
      <section className="why-section">
        <Container sx={{ textAlign: "center" }}>

          <h2 className="why-title">
            Why <span className="highlight">CryptooAnts</span>
          </h2>

          <p className="why-desc">
            CryptooAnts Is A Marketplace For Crypto Price Estimates That Bridges Verified
            Crypto Experts Price Estimate With Crypto Exchange And Trading Apps.
            We Help Retail Trader/Investor Make Informed Decision By Aggregating And
            Tracking Real Time Crypto Insights.
          </p>

          <p className="why-desc" style={{ marginTop: "16px" }}>
            Our Goal Is To Cut The Noise And Help Busy Professionals To Participate
            In Crypto With Ease By Supporting With Verified Experts Ready To Use
            Crypto Price Estimates.
          </p>

          {/* FEATURE CARDS */}
          <Grid container className="feature-row" sx={{ mt: 5 }}>

            {/* CARD 1 */}
            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="feature-card">
                <img src={VerifiedExpertBacked} alt="Verified Expert" className="feature-icon-img" />
                <h5 className="feature-title">Verified Expert Backed</h5>
                <p className="feature-text">
                  Access insight from Certified Crypto Expert
                </p>
              </div>
            </Grid>

            {/* CARD 2 */}
            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="feature-card">
                <img src={HumanAIPrecision} alt="AI Precision" className="feature-icon-img" />
                <h5 className="feature-title">Human + AI Precision</h5>
                <p className="feature-text">
                  Achieve 60% and above success with Crypto Expert
                </p>
              </div>
            </Grid>

            {/* CARD 3 */}
            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="feature-card">
                <img src={InstantAlert} alt="Instant Alert" className="feature-icon-img" />
                <h5 className="feature-title">Instant Alert</h5>
                <p className="feature-text">
                  Get instant alerts on new recommendation Target & Stoploss
                </p>
              </div>
            </Grid>

            {/* CARD 4 */}
            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="feature-card">
                <img src={RealTimerecommendationtracking} alt="Real Time" className="feature-icon-img" />
                <h5 className="feature-title">Real Time Tracking</h5>
                <p className="feature-text">
                  Get price estimate in structured format with real time tracking
                </p>
              </div>
            </Grid>

          </Grid>

        </Container>
      </section>

      {/* OUR PRODUCTS SECTION */}
      <section className="products-section">
        <h2 className="section-title">Our Products</h2>
        <div className="section-divider"></div>

        {/* PRODUCT 1 */}
        <div className="product-block">
          <img src={CryptooAntsPremiumIcon} alt="icon" className="product-icon" />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            <h1 className="product-number">01</h1>
            <h3 className="product-name">CryptooAnts Premium</h3>
          </div>
          <p className="product-desc">
            CryptooAnts Premium is an advanced module where verified experts can publish
            crypto price recommendations (supports 1–day, intraday, swing & quant type).
          </p>
          <img src={CryptooAntsPremiumImage} alt="Product" className="product-img" />
        </div>

        {/* PRODUCT 2 */}
        <div className="product-block">
          <img src={CryptoBuzzIcon} alt="icon" className="product-icon" />
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            <h1 className="product-number">02</h1>
            <h3 className="product-name">CryptooBuzz</h3>
          </div>
          <p className="product-desc">
            CryptooBuzz is an in-depth research dashboard where experts publish news,
            updates, market insights & on-chain analysis.
          </p>
          <img src={CryptoBuzzImage} alt="Product" className="product-img" />
        </div>
      </section>

      {/* PLATFORM ACHIEVEMENTS SECTION */}
      <section className="achievements-section">
        <h2 className="achievements-title">Platform Achievements</h2>

        <Container>
          <Grid container sx={{ textAlign: "center" }} className="achievement-row">

            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="achievement-card">
                <img src={VerifiedCryptoExperts} className="ach-icon" alt="" />
                <h3 className="ach-count">+40</h3>
                <p className="ach-text">Verified Crypto Experts</p>
              </div>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="achievement-card">
                <img src={DailyInstaSwingRecommendations} className="ach-icon" alt="" />
                <h3 className="ach-count">+15</h3>
                <p className="ach-text">Daily Insta & Swing Recommendations</p>
              </div>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="achievement-card">
                <img src={AvgSuccessrate} className="ach-icon" alt="" />
                <h3 className="ach-count">50~60%</h3>
                <p className="ach-text">Avg Success rate</p>
              </div>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 3 }} sx={{ mb: 4 }}>
              <div className="achievement-card">
                <img src={CryptoCoinsCovered} className="ach-icon" alt="" />
                <h3 className="ach-count">+100</h3>
                <p className="ach-text">Crypto Coins Covered</p>
              </div>
            </Grid>

          </Grid>
        </Container>
      </section>

      {/* WHY PARTNER SECTION */}
      <section className="partner-section">
        <h2 className="partner-title">Why Partner With CryptooAnts</h2>

        <Container>
          <Grid container className="partner-row">

            <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 3 }}>
              <div className="partner-card">
                <img src={avatar} className="partner-icon" alt="" />
                <span>
                  Community of <span style={{ fontWeight: "bold" }}>Verified Crypto experts</span>
                </span>
              </div>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 3 }}>
              <div className="partner-card">
                <img src={rightArrow} className="partner-icon" alt="" />
                <span>
                  Ready to Trade Ideas for{" "}
                  <span style={{ fontWeight: "bold" }}>Beginners & Busy Professionals</span>
                </span>
              </div>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 3 }}>
              <div className="partner-card">
                <img src={icon3} className="partner-icon" alt="" />
                <span>
                  Ready to Plugin <span style={{ fontWeight: "bold" }}>B2B</span> Integration
                </span>
              </div>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 3 }}>
              <div className="partner-card">
                <img src={icon4} className="partner-icon" alt="" />
                <span>
                  <span style={{ fontWeight: "bold" }}>Unrestricted Data</span> & Unlimited Users
                </span>
              </div>
            </Grid>

          </Grid>
        </Container>
      </section>

      {/* ABOUT US SECTION */}
      <section className="about-section" id="about">
        <Container className="about-container">
          <Grid container alignItems="center">

            <Grid size={{ xs: 12, md: 6 }}>
              <h2 className="about-title">About us</h2>
              <p className="about-text">
                CryptooAnts is a India's first Crypto marketplace Platform, Where we cut the noise by scouting, training, verifying the crypto expert - to help with ready to plugin crypto price estimates to serve beginners/Busy Professionals participates actively in crypto markets.
              </p>

              <p className="about-text">
                Founded by a team passionate about democratizing financial intelligence, we connect retail traders, developers, and analysts — empowering confident trading for everyone.
              </p>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }} sx={{ textAlign: "center" }}>
              <img
                src={aboutGroup}
                className="about-img"
                alt="Crypto Graphic"
              />
            </Grid>

          </Grid>
        </Container>
      </section>

      {/* CONTACT CTA SECTION */}
      <section className="unique-section" id="contact">
        <Container className="unique-wrapper">

          {/* LEFT IMAGE */}
          <div className="unique-left">
            <img
              src={Footerimg}
              alt="Crypto 3D"
              className="unique-img"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="unique-right">
            <h2 className="unique-title">
              Have a unique <br /> requirement?
            </h2>

            <p className="unique-subtitle">Let's discuss it</p>
          </div>

          <div className="partner-contact">
            <button className="unique-btn">
              Connect with Us <span className="unique-arrow">⬇</span>
            </button>

            <div className="unique-contact">
              <div className="unique-row">
                <img src={gmail} alt="mail" className="unique-icon" />
                partner@cryptooants.com
              </div>

              <div className="unique-row">
                <img src={require("../../assets/Icons/phone.jpeg")} alt="phone" className="unique-icon" />
                9321765323
              </div>
            </div>
          </div>

        </Container>
      </section>

      {/* DISCLAIMER SECTION */}
      <section className="disclaimer-section">
        <Container>
          <h3 className="disclaimer-title">Disclaimer</h3>

          <p className="disclaimer-text">
            CryptooAnts is a marketplace for crypto price estimates. All price predictions, recommendations,
            and analytics are provided on an "as is" basis—without warranty or guarantee of any kind.
          </p>

          <p className="disclaimer-text">
            CryptooAnts does not provide investment advice, portfolio management, or personalized guidance.
            All content is solely informational, and the responsibility for investment decisions lies with the user.
            Past performance is not indicative of future results; the cryptocurrency market is inherently risky and volatile.
          </p>

          <p className="disclaimer-text">
            While we strive to maintain accuracy and update recommendations in real-time, CryptooAnts is not liable for losses
            incurred from acting on published content, delays in data, or service outages.
          </p>

          <p className="disclaimer-text">
            By using CryptooAnts, you acknowledge the speculative nature of crypto markets and agree to use the platform
            at your own risk. Users are strongly advised to perform their own independent due diligence and seek advice
            from registered financial professionals before making any trades based on CryptooAnts' signals.
          </p>
        </Container>
      </section>

      <section className="faq-section">
        <Container>
          <div className="footer-divider"></div>
          <h3 className="faq-title">Frequently Asked Questions</h3>

          <div className="faq-item">
            <h4 className="faq-question">What is CryptooAnts Premium?</h4>
            <p className="faq-answer">
              CryptooAnts Premium is a structured module where verified experts publish crypto
              recommendations (perpetual futures – intraday, swing, or quarterly). All recommendations
              follow predefined parameters to maintain quality and consistency.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">Who qualifies as a verified crypto expert?</h4>
            <p className="faq-answer">
              Verified Crypto Analysts are experts who have built a performance track record on the
              platform. Their recommendations are monitored, and sustained accuracy earns them a
              Verified Tick Mark.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">What kind of recommendations can be published?</h4>
            <p className="faq-answer">
              Experts can publish directional trades on leading crypto assets (Top 50–100 tokens),
              including entry range, stop loss, and target levels.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">What is the typical structure of a recommendation?</h4>
            <ul className="faq-list">
              <li>Token Name</li>
              <li>Contract Type</li>
              <li>Trade Direction (Long / Short)</li>
              <li>Entry Range</li>
              <li>Targets (T1 & T2)</li>
              <li>Stop Loss Levels</li>
              <li>Trade Validity</li>
              <li>Chart Snapshot & Tags</li>
            </ul>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">Can experts edit or manage past recommendations?</h4>
            <p className="faq-answer">
              Yes. Experts can view and edit their previously published recommendations from their
              dashboard. Deletions/archivals are handled by the CryptooAnts admin team.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">What is CryptooBuzz?</h4>
            <p className="faq-answer">
              CryptooBuzz is an internal research and insights publishing tool for verified experts to
              share updates, news, and research with B2B partners.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">Are expert posts visible to the public?</h4>
            <p className="faq-answer">
              CryptooBuzz posts are not visible publicly on the website. Distribution is handled via the
              admin panel.
            </p>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">What content formats are supported on CryptooBuzz?</h4>
            <ul className="faq-list">
              <li>Text-based insights</li>
              <li>Images (charts or visuals)</li>
              <li>Trade Direction (Long / Short)</li>
              <li>PDF or DOC reports</li>
              <li>Multiple formats can be combined in a single post.</li>
            </ul>
          </div>

          <div className="faq-item">
            <h4 className="faq-question">Can experts download or access their published material?</h4>
            <p className="faq-answer">
              Yes. Experts can download their own content as a zip file containing the text, images, and attachments.
            </p>
          </div>

        </Container>
      </section>

      <section className="footer-section">
        <Container>

          {/* Divider */}
          <div className="footer-divider"></div>

          {/* Middle Row */}
          <div className="footer-row">
            <div className="footer-spacer"></div>

            {/* Text Section */}
            <div className="footer-text">
              <p>@Initiative in CryptoMarkets by Established Brand StockAnts</p>
              <p>© 2025 CryptooAnts. All rights reserved.</p>
            </div>

            {/* Social Icons */}
            <div className="footer-social">
              <div className="footer-follow-text">Follow us on</div>

              <div className="footer-social-icons">
                <a href="#" className="footer-icon">
                  <img src={facebook} alt="F" className="footer-social-img" />
                </a>

                <a href="#" className="footer-icon">
                  <img src={instagram} alt="I" className="footer-social-img" />
                </a>

                <a href="#" className="footer-icon">
                  <img src={linkedin} alt="Li" className="footer-social-img" />
                </a>

                <a href="#" className="footer-icon">
                  <img src={twitter1} alt="X (Tw)" className="footer-social-img" />
                </a>
              </div>
            </div>

          </div>
        </Container>
      </section>

    </div>
  );
}
